import { INFO_URL } from '../constants';

export const openInfo = () => {
    window.open(INFO_URL, '_blank');
};
